import { init } from "../init";
import { JiraSoftwareFeaturesPage } from "../pages/software/jira/features/jira-software-features-page";

init(JiraSoftwareFeaturesPage);
